module.exports = __webpack_public_path__ + "static/media/2.4646655b.png";